import type { OrganizationType } from '@mntn-dev/domain-types'
import type { RoutesTFunction, RoutesTKeyRoots } from '@mntn-dev/i18n'
import { hasProperty } from '@mntn-dev/utilities'
import type { AnyRoute } from '../route.ts'

export const hasNameAttributes = (attributes: unknown) =>
  hasProperty<'name', RoutesTKeyRoots>(attributes, 'name')

export const getNameAttribute = ({ route }: { route: AnyRoute }) =>
  hasNameAttributes(route.attributes) ? route.attributes.name : undefined

export const translateRouteName = ({
  route,
  t,
  organizationType,
}: {
  route: AnyRoute
  t: RoutesTFunction
  organizationType: OrganizationType
}) =>
  hasNameAttributes(route.attributes)
    ? t(`${route.attributes.name}.${organizationType}`)
    : undefined
